<template>
  <div class="container-fluid">
    <b-card no-body class="card-transparent-background">
      <b-card-title class="card-title-doom-yoga">
        Subscriptions and Packs
      </b-card-title>
    </b-card>
    <div class="">
      <b-tabs class="evnetTypesTabs" v-model="tabIndex">
        <b-tab
          title="On Demand Subscriptions"
          title-link-class="btn btn-bumblebee btn-doomyoga btn-tab btn-doomyoga-secondary"
          lazy
          active
        >
          <DoomYogaOnDemandSubscriptions />
        </b-tab>
        <b-tab
          title="Full Memberships"
          title-link-class="btn btn-bumblebee btn-doomyoga btn-tab btn-doomyoga-secondary"
          lazy
        >
          <DoomYogaFullMemberships />
        </b-tab>
        <template #tabs-end v-if="tabIndex==1">
          <!-- <li role="presentation" class="nav-item align-self-right"></li> -->

          <li
            role="presentation"
            class="nav-item custom-nav-item-right"
          >
            <b-button
              variant="doomyoga-primary"
              class="btn-bumblebee btn-doomyoga btn-filter"
            >
              Create New Membership
            </b-button>
          </li>
        </template>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import DoomYogaOnDemandSubscriptions from "./OnDemandSubscriptions.vue";
import DoomYogaFullMemberships from "./FullMemberships.vue";

export default {
  name: "DoomYogaMembershipsPacks",
  components: { DoomYogaOnDemandSubscriptions, DoomYogaFullMemberships },
  data() {
    return {
      tabIndex: 0,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/admin/memberships_packs/Index.vue